.key {
  display: inline-grid;
  place-items: center;
  min-width: 18px;
  height: 18px;
  padding: 0 var(--space-1);
  border: var(--hairline) solid color-mix(in srgb, currentColor 60%, transparent);
  border-radius: var(--radius-tag);
  font: var(--text-caption-2);
  font-weight: 500;
  color: var(--label-3);
}

.onInk {
  color: color-mix(in srgb, var(--on-ink) 75%, transparent);
}

@media (pointer: coarse) {
  .key {
    display: none;
  }
}
